import React from "react";
import "./text.css";
import "./textMobile.css";

class Text extends React.Component {
  render() {
    if (this.props.header) {
      return (
        <div className="contentBlock text">
          <h1 className="display-font title">{this.props.header}</h1>
          <p className="body-font role">{this.props.text}</p>
        </div>
      );
    }
    return (
      <div className="contentBlock text">
        <p className="body-font role no-header">{this.props.text}</p>
      </div>
    );
  }
}
export default Text;
